import { Environment } from '@abp/ng.core';

export interface CiamBffConfig {
  baseUrl: string;
  exchangePath: string;
  refreshPath: string;
  logoutPath: string;
  customerPath: string;
}

export interface CiamConfig {
  enabled: boolean;
  authAppBaseUrl: string;
  callbackPath: string;
  signInPath: string;
  registerPath: string;
  activationPath: string;
  forgotPasswordPath: string;
  bff: CiamBffConfig;
}

export interface CastoramaEnvironment extends Environment {
  ciam: CiamConfig;
}

/**
 * Deux environnements CIAM sont utilisés : h-tier pour tous les environnements de test, de
 * recette et de staging, production pour la production. Les gateways Test NG et Prod-staging
 * ne sont volontairement pas exposées.
 */
export const CIAM_AUTH_APP_BASE_URLS = {
  hft: 'https://auth.h-tier.castorama.fr',
  production: 'https://auth.castorama.fr',
} as const;

export const disabledCiamConfig = (backendBaseUrl: string): CiamConfig => ({
  enabled: false,
  authAppBaseUrl: '',
  callbackPath: '/auth/callback',
  signInPath: '/signin',
  registerPath: '/register',
  activationPath: '/activation',
  forgotPasswordPath: '/forgot-password',
  bff: {
    baseUrl: backendBaseUrl,
    exchangePath: '/api/app/ciam/exchange',
    refreshPath: '/api/app/ciam/refresh',
    logoutPath: '/api/app/ciam/session',
    customerPath: '/api/app/ciam/customer',
  },
});
